export default __webpack_public_path__ + "static/media/javascript.ba40d6a9.svg";